import { isAssignorComplete } from '@/utils/mixins/flux-control'
const Dashboard = () => import('@app/dashboard')

export default [
  {
    path: '/',
    name: 'dashboard.index',
    component: Dashboard,
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      isAssignorComplete(next)
    }
  }
]



// WEBPACK FOOTER //
// ./src/features/dashboard/routes.js